import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "managerial-structure" */ '@/views/managerial-structure/Index');
let create = () => import(/* webpackChunkName: "managerial-structure" */ '@/views/managerial-structure/Create');
let edit = () => import(/* webpackChunkName: "managerial-structure" */ '@/views/managerial-structure/Edit');

export default [
    {
        path: "/managerial-structure",
        name: "managerial-structure.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['managerial-structures:viewAny'],
            title: "ساختار مدیریتی"
        }
    },
    {
        path: "/managerial-structure/create/:parentId?",
        name: "managerial-structure.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['managerial-structures:create'],
            title: "ایجاد ساختار مدیریتی"
        }
    },
    {
        path: "/managerial-structure/:id",
        name: "managerial-structure.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['managerial-structures:update'],
            title: "ویرایش ساختار مدیریتی"
        }
    },
]
